import { axiosInstance as axios } from "services";

export const updatePaymentStatus = async (companyId, body) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/payment-status`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to update payment status");
  return data;
};

